import React from "react";
import ServiceHero from "../../components/ServiceHero";

const SoftwareHome = () => (
  <ServiceHero
    eyebrow="Software Development"
    title="Custom software that fits"
    highlight="the way you work."
    description="We translate complex operations into dependable software that simplifies workflows, connects teams, and creates room for your business to scale."
    features={[
      "Purpose-built architecture",
      "Smarter workflow automation",
      "Reliable long-term support",
    ]}
    image="/Images/softwarebgimg.jpg"
    imageAlt="A team planning and building custom business software"
    imageFit="cover"
    visualLabel="Software shaped around you"
    visualTitle="The right systems for the way your business actually operates."
  />
);

export default SoftwareHome;
